import { shallowEqual, useSelector } from "react-redux";
import { StoreType } from "../redux/StoreType";
import { GET_USER_STATE } from "../redux/slices/userSlice";
import { GET_VENDOR_IMPERSONATION_STATE } from "../redux/slices/impersonationSlice";

export function useVehiclesDetailsPageData(vdr: string | string[]) {
  const {
    user: { isVendorAdmin },
  }: StoreType = useSelector(GET_USER_STATE, shallowEqual);
  const {
    impersonation: { isVendorImpersonationSet },
  }: StoreType = useSelector(GET_VENDOR_IMPERSONATION_STATE, shallowEqual);

  const isVendorAdminImpersonating = isVendorAdmin && isVendorImpersonationSet;
  const shouldRestrict = isVendorAdminImpersonating && vdr === "vp";

  return {
    shouldRestrict,
  };
}

export default useVehiclesDetailsPageData;
